<template>
	<div class="section-types padding-top-70 padding-bottom-70">
		<section-title component-class="margin-bottom-50">
			<h2>
				<span class="fw-400">{{ $t('Section.TypesContainerSentence1') }}</span>
				{{ $t('Section.TypesContainerSentence2') }}
			</h2>
			<p v-html="$t('Section.TypesContainerSentence3', ['/request/create/1'])"></p>
		</section-title>

		<div v-if="requestTypes" class="container">
			<div class="row">
				<types-container-box v-for="(value, key) in requestTypes" v-once :key="key" :item="value"></types-container-box>
			</div>
		</div>
	</div>
</template>

<script>
import SectionTitle from '@/components/partials/SectionTitle'
import ServiceHelper from '@/mixins/ServiceHelper'
import TypesContainerBox from '@/components/sections/boxes/TypesContainerBox'

export default {
	name: 'TypesContainer',
	components: {
		SectionTitle,
		TypesContainerBox,
	},
	mixins: [ServiceHelper],
	data() {
		return {
			requestTypes: null,
		}
	},
	created() {
		if (sessionStorage.getItem('ius_request_types')) {
			// If available, use session storage request types
			this.requestTypes = JSON.parse(sessionStorage.getItem('ius_request_types'))
		} else {
			// Retrieve request types from API and store in session storage
			this.loadData()
		}
	},
	methods: {
		loadData() {
			// Get data
			axios
				.get('/request-types', {
					params: this.loadAllParams,
				})
				.then((response) => {
					this.requestTypes = response.data.info
					sessionStorage.setItem('ius_request_types', JSON.stringify(this.requestTypes))
				})
				.catch((error) => {
					console.log(error)
				})
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/components/sections/TypesContainer.vue